<template>
  <div>
    <!--  -->
    <mrc_ess_table
      v-if="$route.name == 'cost-center'"
      :headers="headers"
      pageName="add-cost-center"
      :paginationOptions="options"
      :hideAddBtn="!hasBtn('add-cost-center')"
      @turnPage="getlist"
      :isLoading="loading"
      :slotKey="['cost_center', 'effective_date']"
      :items="desserts"
    >
      <template v-slot:btns>
        <mrc_ess_uploadBtn
          type="5"
          :hrefUrl="uploadUrl"
          class="ml-4"
          v-btnAuth="['upload-cost-center']"
          :label="$t('label_Batch_Import')"
        >
        </mrc_ess_uploadBtn>
        <!-- <v-btn rounded
               tag='a'
               depressed
               height="40"
               style="position:relative;"
               v-btnAuth="['download-cost-center-template']"
               class="ml-4"
               :href='uploadUrl'
               color="primary">
          {{$t('label_Download_the_template')}}
        </v-btn> -->
      </template>

      <template v-slot:search>
        <v-row
          class="d-flex justify-end"
          style="background: white;
          margin: 0;
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;padding: 0 16px"
        >
          <mrc_ess_advanceFilterAndSearchInput
            class="mt-4"
            v-model="systemSeniorQueryString"
            @success="getlist({ cpage: 1 })"
            :systemFieldMeta="systemFieldMeta"
          ></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template>
      <!-- <template v-slot:item.id="{ item }">
        <span> {{ item.id }}</span>
      </template> -->

      <template v-slot:item.cost_center="{ item }">
        <div class="d-flex flex-column">
          <span>
            {{ INT(item.cost_center_name) }}
          </span>
          <span class="text-caption  text--secondary">
            {{ INT(item.cost_center_description) }}
          </span>
        </div>
      </template>

      <template v-slot:item.effective_date="{ item }">
        <span>
          {{ item.effective_start_date | changeDate() }}
        </span>
        <span class="mx-1">
          -
          <!-- {{ $t('label_to') }} -->
        </span>
        <span>
          {{ item.effective_end_date | changeDate() }}
        </span>
      </template>

      <!-- 操作 -->
      <template v-slot:item.actions="{ item }">
        <menu-list :list="menulist" @handleClick="handleClick($event, item)">
          <template v-slot:showAction>
            <!--  -->
            <v-icon
              v-btnAuth="[
                'view-cost-center',
                'edit-cost-center',
                'delete-cost-center',
              ]"
              >mdi-dots-vertical</v-icon
            >
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import {
  costCenterList,
  addCostCenter,
  delCostCenter,
  updateCostCenter,
  detailCostCenter,
} from "@/service/api/costCenter.js"
import { COST_CENTER_URL } from "@/utils/constant/index.js"
export default {
  components: {},
  props: {},
  data() {
    return {
      uploadUrl: "",
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      disabled: true,
      list: {},
      options: {
        pagesize: this.$store.state.pageSize, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
      },
      loading: false,
      uploadLoading: false,
      desserts: [],
    }
  },
  computed: {
    menulist() {
      return [
        {
          name: this.$t("label_View"),
          show: this.hasBtn("view-cost-center"),
          type: "view",
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("edit-cost-center"),
          type: "edit",
        },
        {
          name: this.$t("label_delete"),
          show: this.hasBtn("delete-cost-center"),
          type: "del",
        },
        // { name: this.$t('label_View'), show: true, type: 'view' },
        // { name: this.$t('label_Edit'), show: true, type: 'edit' },
        // { name: this.$t('label_delete'), show: true, type: 'del' },
      ]
    },
    headers() {
      return [
        // {
        //   text: 'ID',
        //   align: 'start',
        //   value: 'id',
        //   sortable: false,
        // },
        {
          text: this.$t("label_cost_center_name_and_description"),
          value: "cost_center",
          align: "start",
          sortable: false,
        },
        {
          text: this.$t("label_The_effective_date"),
          value: "effective_date",
          sortable: false,
          align: "start",
        },
        { text: "", value: "actions", sortable: false, align: "end" },
      ]
    },
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1)
  },
  created() {
    this.uploadUrl = COST_CENTER_URL
  },
  watch: {
    $route(v) {
      if (v.name == "cost-center") {
        this.getlist()
      }
    },
  },
  mounted() {
    this.getBtnPermissionList()
    this.getlist()
  },
  beforeDestroy() {},
  methods: {
    async getlist(obj) {
      this.loading = true
      if (
        this.desserts &&
        this.desserts.length == 1 &&
        this.options.cpage != 1 &&
        this.$route.params.type == "del"
      )
        this.options.cpage--
      if (obj) {
        const { cpage, pagesize } = obj

        this.options = { ...this.options, ...obj }
      }
      const res = await costCenterList({
        cpage: this.options.cpage,
        pagesize: this.options.pagesize,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      })
      if (res.code == 200) {
        this.desserts = res.data
        this.options.totalcount = res.totalcount
        this.options.totalpage = res.totalpage
        this.systemFieldMeta = res.systemFieldMeta
        this.field_alias_name = res.field_alias_name
        this.table_alias_name = res.table_alias_name
      }
      this.loading = false
    },
    addStaffLeave() {
      this.$store.commit("set_subPage_name", "")
      this.$store.commit("set_uuid", "")
      this.$store.commit("set_iconstatus", "") //行内进图标显示
      this.$router.push({
        name: "addStaffLeave",
      })
    },
    godetail(item) {
      this.$store.commit("set_iconstatus", true) //行内进图标显示
      this.$store.commit("set_subPage_name", this.INT(item.cost_center_name))
      this.$store.commit("set_uuid", item.uuid) //
      this.$router.push({
        name: "detail-cost-center",
      })
    },
    handleClick({ index, item }, obj) {
      switch (item.type) {
        case "view":
          this.godetail(obj)
          break
        case "edit":
          this.$store.commit("set_subPage_name", this.INT(obj.cost_center_name))
          this.$store.commit("set_iconstatus", false) //行内进图标显示
          this.$store.commit("set_uuid", obj.uuid) //
          this.$router.push({
            name: "detail-cost-center",
          })
          break
        case "del":
          this.$myConfirm({
            content: this.$t("message_Confirm_the_deletion"),
          }).then((res) => {
            delCostCenter({ uuid: obj.uuid }).then((res) => {
              if (res.code == 200) {
                this.$Message({
                  text: this.$t("message_The_deletion_was_successful"),
                })
                if (this.desserts.length == 1) this.options.cpage--
                this.getlist()
              }
            })
          })
          break
      }
    },
    success() {},
    cancel() {},
  },
}
</script>

<style scoped></style>
